const SET_PODCAST_DATA_FETCH_STATUS = 'SET_PODCAST_DATA_FETCH_STATUS';
const SET_PODCAST = 'global/podcast/SET_PODCAST';
const SET_PROFILE_COLOR = 'SET_PROFILE_COLOR';
const SET_HAS_ANCHOR_BRANDING = 'SET_HAS_ANCHOR_BRANDING';

export default {
  SET_PODCAST_DATA_FETCH_STATUS,
  SET_PODCAST,
  SET_PROFILE_COLOR,
  SET_HAS_ANCHOR_BRANDING,
};
